/*
 * Copyright © 2015-2018 Serenova, LLC. All rights reserved.
 */

import { connect } from 'react-redux';
import { compose } from 'redux';
import { reduxForm } from 'redux-form/immutable';
import OutboundIdentifierListsForm from './layout';
import { formValidation } from './validation';
import {
  getSelectedEntityId,
  isCreating,
  userHasCurrentFormPermission
} from '../../../redux/modules/entities/selectors';
import { selectFormInitialValues, formSubmission, createFormName } from '../../../redux/modules/form/selectors';

const CreateOutboundIdentifierListsForm = compose(
  connect(createFormName),
  reduxForm({
    onSubmit: formSubmission,
    validate: formValidation,
    destroyOnUnmount: true
  })
)(OutboundIdentifierListsForm);

export function mapStateToProps(state) {
  return {
    initialValues: selectFormInitialValues(state),
    isSaving: isCreating(state),
    userHasCurrentFormPermission: userHasCurrentFormPermission(state),
    key: getSelectedEntityId(state)
  };
}

export default connect(mapStateToProps)(CreateOutboundIdentifierListsForm);
